import PropTypes from "prop-types";

export default function DropdownInput({ value, onSelect }) {
  return (
    <li
      onClick={() => onSelect(value)}
      className="cursor-pointer py-2 px-3 hover:bg-blue-100 transition ease-in-out duration-300 text-sm"
    >
      {value}
    </li>
  );
}

DropdownInput.propTypes = {
  value: PropTypes.string,
  onSelect: PropTypes.func,
};

DropdownInput.displayName = "DropdownInput";
